import React, { useState, useEffect } from 'react';

import Header from "../../../Components/clubDashboard/Header/Header";

import Switch from "react-switch";
import combinedServices from "../../../shared/services/user-service";
import getRemoveData from '../../../shared/localStorage/removeData';
import getLocalData from "../../../shared/localStorage/getData";
import { NavLink, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import { Spinner } from 'reactstrap';
import SelectSearch, { fuzzySearch } from 'react-select-search';

const PaymentGateway = () => {
    let navigate = useNavigate();
   
    const [isLoder, setIsLoder] = useState(true)

    const [allPayment, setAllPayment] = useState([]);
    const [allUsers,setAllUser] = useState([]);
   
    const [userId,setUserId] = useState("");
   



    useEffect(async () => {
        if (getLocalData("admin_info", "isLogin")) {
            var paymentArr = [];
            var payData = {
                user_id :""
            }
           // let paymentAll = await combinedServices.getPaymentAdmin(payData);
            let refundAll = await combinedServices.getAllRefundForAdmin(payData);
         
            if(refundAll.status==401){
                swal(refundAll.msg, "Please Re-login", "warning").then(() => {
                  getRemoveData("user_info");
                  localStorage.clear();
                  window.location.href = "/login";
                });
              }

            //setAllClubDetails(clubResponse.data);
            if (refundAll.status == 200) {
                setIsLoder(false)
                refundAll.data.map((pay) => {
                    var refundDetails = pay.event_participant_class ;
                   
                    var user = refundDetails.event_participant.user.user_firstname + " " + refundDetails.event_participant.user.user_lastname ;
                   
                   
                    var data = {

                        //payment_for: pay.payment_for,
                        amount: pay.amount,
                        //payment_status: pay.payment_status,
                        payment_type:pay.payment_type,
                        class_name :refundDetails.class.name ,
                        full_title :refundDetails.event_participant.event.full_title ,
                        user :user



                    }

                    

                    paymentArr.push(data)

                })

              


                setAllPayment(paymentArr)


            }

            let usersResponse = await combinedServices.getAllUser();
            var userArr = [] ;
            

            usersResponse.data.map((user)=>{

                var data = {
                    name : user.user_firstname+" "+user.user_lastname ,
                    value : user.id


                }
                userArr.push(data)
            
            })

            setAllUser(userArr) ;

        }
    }, [])

    const handleSearchBox = async(e) =>{
        setUserId(e)
       
        var data = {
            user_id: e

        }
        var paymentArr = [];
        let refundAll = await combinedServices.getAllRefundForAdmin(data);
          
            

            //setAllClubDetails(clubResponse.data);
            if (refundAll.status == 200) {
                setIsLoder(false)
                refundAll.data.map((pay) => {
                    var refundDetails = pay.event_participant_class ;
                   
                    var user = refundDetails.event_participant.user.user_firstname + " " + refundDetails.event_participant.user.user_lastname ;
                   
                   
                    var data = {

                        //payment_for: pay.payment_for,
                        amount: pay.amount,
                        //payment_status: pay.payment_status,
                        payment_type:pay.payment_type,
                        class_name :refundDetails.class.name ,
                        full_title :refundDetails.event_participant.event.full_title ,
                        user :user



                    }

                    

                    paymentArr.push(data)

                })

               

                setAllPayment(paymentArr)


            }
        

    }



    return (
        <>
            <Header />
            <div className="dbAdminRight">
                <div className="dbMid dbInner">
                    <div className="flexBox spacebetween topHdBox">
                        <div className="left">
                        <SelectSearch
          options={allUsers}
          value={userId}
          
          onChange={handleSearchBox}
          search
          filterOptions={fuzzySearch}
          placeholder="Search something"
          className="select-search"
        />
                             




                        </div>

                    </div>
                    <div className='flexBox spacebetween'>
                        <div className='pgBox whtBox'>
                            <div className="interfaceTable">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Sr. No</th>
                                            <th>User Name</th>
                                            <th>Event Name</th>
                                            <th>Class Name</th>
                                           
                                            <th>Payment Amount</th>
                                            
                                            <th>Payment Type </th>

                                        </tr>
                                    </thead>
                                    {isLoder ? <div className="text-center mt-4 loadMore"><Spinner color="primary" /></div> : <>
                                        <tbody>
                                            {allPayment.length > 0 ? allPayment.map((paymentDetails, index) => {
                                                return (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{paymentDetails.user}</td>
                                                        <td>{paymentDetails.full_title}</td>
                                                        <td>{paymentDetails.class_name}</td>
                                                        
                                                        

                                                        <td>
                                                            <div className='dec'>{paymentDetails.amount}</div>
                                                        </td>
                                                        
                                                        {paymentDetails.payment_type == "PAY_AT_RACE" &&
                                                            <td>
                                                                <div className='dec'>Pay At Race</div>
                                                            </td>
                                                        }
                                                         {paymentDetails.payment_type == "PAYPAL" &&
                                                            <td>
                                                                <div className='dec'>Paypal</div>
                                                            </td>
                                                        }
                                                         {paymentDetails.payment_type == "MAIL_IN" &&
                                                            <td>
                                                                <div className='dec'>Mail IN</div>
                                                            </td>
                                                        }


                                                    </tr>


                                                )


                                            }) : <tr>
                                                <td></td>
                                                <td></td>
                                                <td><div className="noEvent">Not Found Any Club Paypal Credentials</div></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
}


                                        </tbody>
                                    </>}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )

}
export default PaymentGateway;